import QuickFactsComponent from './QuickFactsComponent';

export default QuickFactsComponent;
